module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAIaGhiubOSqcOSmcOSuaOCyaODOXODUkADUcED0YDBQcAFEEBBwQCCQMABQQAD0AADEAAC0AACQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEHABcALAAAAAAgACAAAAW+4CWOZGmeaGparKW+K+nCsDUM4j3TqH3/Ot7JBwTuhBdi0YhM2lgVJfMFqLYG0EhkGaS2bBJJa7tMvliRyY+SaC2KouPK8ngUE2104RdPfbkIDiwTSmZDV1wDDg0WhFNzYYk/BwcsP3IjY5JGllg9m6CYcTpSkl+fWIibDBAsPT5fpTcGAwotfpyqRV8AuLkUpby9qLmdN4SuF8PEl38DUck0wWGWt0jBD9WiNUud29KJ3zzBTcTR5XPn6OsoIQA7"


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadNE_S1.gif
// module id = a5eU
// module chunks = 44